import { Component, ContentChildren, QueryList } from '@angular/core';
import { RouterTabComponent } from './router-tab.component';

@Component({
    selector: 'router-tab-set',
    templateUrl: './router-tab-set.component.html',
    styleUrls: ['router-tab-set.component.scss'],
    standalone: false
})
export class RouterTabSetComponent {

    @ContentChildren(RouterTabComponent)
    public tabs: QueryList<RouterTabComponent>;


}